"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RunWhenVisible = void 0;
function RunWhenVisible(element, callback, options) {
    const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.intersectionRatio > 0)) {
            callback(element);
            observer.unobserve(element);
        }
    }, options);
    observer.observe(element);
}
exports.RunWhenVisible = RunWhenVisible;
